<template>
  <v-dialog
    v-model="editCustomerModal"
    persistent
    max-width="900px"
  >
    <v-card>
      <form
        action=""
        @submit.prevent="submitForm"
      >
        <v-card-title style="padding-bottom: 0px">
          <v-flex
            xs11
            sm11
            md11
          ><span class="headline">{{ $t('user.updateCustomerTitle') }}</span></v-flex>
          <v-flex
            xs1
            sm1
            md1
          >
            <v-btn
              flat
              @click="closeEditCustomerModal(), $validator.reset()"
              class="close"
            >
              <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
          </v-flex>
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex
              xs12
              sm10
              md12
              class="px-2"
            >
              <v-text-field
                :label="$t('user.customerFullNameLabel') + '*'"
                v-model="editCustomerData.full_name"
                :error-messages="errors.collect('Customer Full Name')"
                data-vv-name="Customer Full Name"
                v-validate="'required|full_name_format'"
              ></v-text-field>

              </v-text-field>
            </v-flex>

            <v-flex
              xs12
              sm12
              md4
              class="px-2"
            >
              <CountryPhoneInput
                ref="phoneInput"
                v-model="editCustomerData.phone_number"
                :label="$t('columns.phoneNumber')"
              />
            </v-flex>

            <v-flex
              xs12
              sm12
              md4
              class="px-2"
            >
              <CountryPhoneInput
                ref="phone2Input"
                v-model="editCustomerData.phone_number_2"
                :label="$t('columns.phoneNumber2')"
                :required="false"
              />
            </v-flex>

            <v-flex
              xs12
              sm12
              md4
              class="px-2"
            >
              <v-text-field
                :label="$t('columns.email')"
                v-model="editCustomerData.email"
                :error-messages="errors.collect('email')"
                v-validate="'email'"
                data-vv-name="email"
              >
              </v-text-field>
            </v-flex>

            <v-flex
              class="px-2"
              xs12
              sm4
              md4
            >
              <v-select
                autocomplete
                :items="localGovernoratesList"
                item-value="governorate_id"
                item-text="governorate_name"
                v-model="editCustomerData.governorate_id_fk"
                :error-messages="errors.collect('Governorate')"
                data-vv-name="Governorate"
                :label="$t('columns.governorate')"
                v-validate="'required'"
                clearable
              >
              </v-select>
            </v-flex>

            <v-flex
              class="px-2"
              xs12
              sm4
              md4
            >
              <v-select
                autocomplete
                :items="localCitiesList"
                item-value="city_id"
                item-text="city_name"
                v-model="editCustomerData.city_id_fk"
                :error-messages="errors.collect('City')"
                data-vv-name="City"
                :label="$t('columns.city')"
                clearable
              >
              </v-select>
            </v-flex>

            <v-flex
              xs12
              sm12
              md4
              class="px-2"
            >
              <v-text-field
                :label="$t('columns.address')"
                v-model="editCustomerData.address"
                data-vv-name="address"
              >
              </v-text-field>
            </v-flex>
<!--
            <v-flex
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-text-field
                label="Price per wight (USA)"
                v-model.number="editCustomerData.item_weight_price_usa"
                data-vv-name="Price per wight (USA)"
                :error-messages="errors.collect('Price per wight (USA)')"
                v-validate="'required|decimal:2'"
              >
              </v-text-field>
            </v-flex>

            <v-flex
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-text-field
                label="Price per wight (Turkey)"
                v-model.number="editCustomerData.item_weight_price_turkey"
                data-vv-name="Price per wight (Turkey)"
                :error-messages="errors.collect('Price per wight (Turkey)')"
                v-validate="'required|decimal:2'"
              >
              </v-text-field>
            </v-flex>

            <v-flex
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-text-field
                label="Base Quantity Charge (Turkey)"
                v-model.number="editCustomerData.quantity_charge_base_turkey"
                data-vv-name="Base Quantity Charge (Turkey)"
                :error-messages="errors.collect('Base Quantity Charge (Turkey)')"
                v-validate="'required|decimal:2'"
              >
              </v-text-field>
            </v-flex>
            <v-flex
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-text-field
                label="Other Quantity Charge (Turkey)"
                v-model.number="editCustomerData.quantity_charge_other_turkey"
                data-vv-name="Other Quantity Charge (Turkey)"
                :error-messages="errors.collect('Other Quantity Charge (Turkey)')"
                v-validate="'required|decimal:2'"
              >
              </v-text-field>
            </v-flex>

            <v-flex
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-text-field
                label="Base Quantity Charge (USA)"
                v-model.number="editCustomerData.quantity_charge_base_usa"
                data-vv-name="Base Quantity Charge (USA)"
                :error-messages="errors.collect('Base Quantity Charge (USA)')"
                v-validate="'required|decimal:2'"
              >
              </v-text-field>
            </v-flex>
            <v-flex
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-text-field
                label="Other Quantity Charge (USA)"
                v-model.number="editCustomerData.quantity_charge_other_usa"
                data-vv-name="Other Quantity Charge (USA)"
                :error-messages="errors.collect('Other Quantity Charge (USA)')"
                v-validate="'required|decimal:2'"
              >
              </v-text-field>
            </v-flex> -->

            <v-flex
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-text-field
                :label="$t('user.newPassword')"
                v-model.number="editCustomerData.new_password"
                data-vv-name="New Password"
                :error-messages="errors.collect('New Password')"
                v-validate="'min:6'"
              >
              </v-text-field>
            </v-flex>

            <v-flex
              v-if="!editCustomerData.base_phone_verified"
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-checkbox
                v-model="editCustomerData.phone_verified"
                :label="$t('columns.verified')"
                style="padding: 0px"
                :ripple="false"
              />
            </v-flex>

            <v-flex
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-switch
                v-model="editCustomerData.cod_enabled"
                color="success"
                :ripple="false"
                :hint="$t('user.codEnabledHint')"
                persistent-hint
              >
                <span slot="label" class="rtl-ml-8">{{ $t('user.codEnabledLabel') }}</span>
              </v-switch>
            </v-flex>

            <v-flex
              xs12
              sm10
              md12
              class="px-2"
            >
              <label
                for="description"
                style="opacity: 0.8; font-size: 14px; margin-bottom: -8px"
              >
                {{ $t('columns.customerNote') }}
              </label>
              <textarea
                v-model="editCustomerData.customer_note"
                class="form-control"
                style="border-bottom: 1px solid blue; font-size: 1.5rem"
                rows="4"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            style="height:auto"
            @click="closeEditCustomerModal(), $validator.reset()"
            outline
            color="normal"
          >{{ $t('common.cancel') }}</v-btn>
          <v-btn
            type="submit"
            style="height:auto" class="rtl-mr-2-5pct"
            outline
            color="success"
          >{{ $t('common.update') }}</v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import CountryPhoneInput from '../shared/CountryPhoneInput.vue'

export default {
  components: {
    CountryPhoneInput
  },

  props: [
    'editCustomer',
    'editCustomerData',
    'editCustomerModal',
    'checkAlert',
    'closeEditCustomerModal',
    'emailError',
    'validationError',
    'backendError',
    'citiesList'
  ],

  data() {
    return {
      localCitiesList: [],
      localGovernoratesList: []
    }
  },

  mounted() {
    this.getGovernorateList()
    this.$validator.extend('full_name_format', {
      validate: value => /^\w+\s+\w+/.test(value),
      message: this.$t('user.fullNameTwoWordsError')
    })
  },

  watch: {
    'editCustomerData.governorate_id_fk'(newVal) {
      if (newVal) {
        this.getCityList(newVal)
      } else {
        this.localCitiesList = []
      }
    },

    // Watch for modal opening to load cities if governorate is already selected
    editCustomerModal(newVal) {
      if (newVal && this.editCustomerData.governorate_id) {
        this.getCityList(this.editCustomerData.governorate_id)
      }
    },

    // Watch for a different customer row being loaded into this reused component instance
    editCustomerData() {
      if (this.$refs.phoneInput) this.$refs.phoneInput.resetTouched()
      if (this.$refs.phone2Input) this.$refs.phone2Input.resetTouched()
    }
  },

  methods: {
    submitForm(event) {
      this.$validator.validateAll().then(res => {
        const phoneValid = this.$refs.phoneInput ? this.$refs.phoneInput.isValid : true
        const phone2Valid = this.$refs.phone2Input ? this.$refs.phone2Input.isValid : true
        if (res && phoneValid && phone2Valid) {
          this.editCustomer()
        }
      })
    },

    getCityList(governorateId) {
      if (!governorateId) {
        this.localCitiesList = []
        return
      }

      let token = localStorage.getItem('access_token')

      axios.get(`api/city/list/${governorateId}`, {
        headers: { Authorization: 'Bearer ' + token }
      }).then((response) => {
        this.localCitiesList = response.data
      }).catch((error) => {
        console.error('Error fetching cities:', error)
        this.localCitiesList = []
      })
    },

    getGovernorateList() {
      let token = localStorage.getItem('access_token')

      axios.get('api/governorate/list', {
        headers: { Authorization: 'Bearer ' + token }
      }).then((response) => {
        this.localGovernoratesList = response.data
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user/editCustomer.vue